import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { JsonLd, useOgTags } from "@/components/store/SeoJsonLd";

export default function Glossary() {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    api.get("/guides/glossary").then((r) => setTerms(r.data)).catch(() => setTerms([]));
    document.title = "Jewellery Glossary — Every Term, Explained | Siyaara";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    meta.content = "Plain-language definitions of jewellery terms — karat, fineness, HUID, hallmark, pavé, making charge and more.";
  }, []);

  useOgTags({ title: "Jewellery Glossary | Siyaara", description: "Every jewellery term, explained plainly.", url: "https://siyaara.com/guides/glossary" });

  return (
    <div className="container-x py-10 max-w-3xl" data-testid="glossary-page">
      {terms && (
        <JsonLd id="glossary-jsonld" data={{
          "@context": "https://schema.org", "@type": "DefinedTermSet",
          name: "Siyaara Jewellery Glossary",
          hasDefinedTerm: terms.map((t) => ({ "@type": "DefinedTerm", name: t.term, description: t.definition })),
        }} />
      )}
      <nav className="text-[11px] font-mono text-stone-400 uppercase tracking-widest">
        <Link to="/" className="hover:text-brand">Home</Link> / <Link to="/guides" className="hover:text-brand">Guides</Link> / Glossary
      </nav>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-2">The jewellery glossary</h1>
      <p className="text-stone-600 mt-2">Every term on a price tag, certificate or product page — decoded.</p>

      <div className="flex flex-wrap gap-2 mt-6" data-testid="glossary-anchors">
        {(terms || []).map((t) => (
          <a key={t.slug} href={`#${t.slug}`} className="px-3 py-1 text-xs border border-stone-300 rounded-full hover:border-brand hover:text-brand transition-colors">{t.term}</a>
        ))}
      </div>

      <dl className="mt-8 divide-y divide-stone-200 border-y border-stone-200">
        {(terms || []).map((t) => (
          <div key={t.slug} id={t.slug} className="py-4 scroll-mt-24" data-testid={`term-${t.slug}`}>
            <dt className="font-heading font-semibold">{t.term}</dt>
            <dd className="text-sm text-stone-600 mt-1 leading-relaxed">{t.definition}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
